import ControlBase from '../fabric/ControlBase';
import { fabric } from 'fabric';

// Control for changing the progress bar percentage.
class ProgressBarControl extends ControlBase {
  cursorStyle = 'move';
  minDimension = 12;
  layout: 'row' | 'column' = 'row';

  constructor({ layout = 'row' }: { layout?: 'row' | 'column' }) {
    super({});
    this.layout = layout;
    if (this.layout === 'row') {
      this.x = 0;
      this.y = 0.5;
      this.offsetY = 20;
    } else {
      this.x = 0.5;
      this.y = 0;
      this.offsetX = 20;
    }
  }

  positionHandler(dim, finalMatrix, fabricObject) {
    const layout = this.layout;

    // For objects with multiple layouts, we can't rely on potentially stale
    // layoutX/Y values
    if (layout === 'row') {
      this.offsetX = 0;
      this.offsetY = 20;
    } else {
      this.offsetX = 20;
      this.offsetY = 0;
    }

    const x =
      layout === 'row'
        ? (-0.5 + Math.max(Math.min(fabricObject.progress, 1), 0)) * dim.x
        : 0.5 * dim.x + this.offsetX;
    const y =
      layout === 'row'
        ? 0.5 * dim.y + this.offsetY
        : (-0.5 + Math.max(Math.min(fabricObject.progress, 1), 0)) * dim.y;
    return fabric.util.transformPoint(new fabric.Point(x, y), finalMatrix);
  }

  getActionHandler(): fabric.ControlMouseEventHandler {
    return (
      eventData: MouseEvent,
      transform: fabric.Transform,
      x: number,
      y: number
    ) => {
      const object = transform.target;
      const dim = object._getTransformedDimensions();
      const localPoint = fabric.controlsUtils.getLocalPoint(
        transform,
        transform.originX,
        transform.originY,
        x,
        y
      );
      // Constrain the value between 0 and 1
      const coordinate =
        this.layout === 'row' ? localPoint.x / dim.x : localPoint.y / dim.y;
      const progress = Math.min(Math.max(coordinate, 0), 1);
      object.setOnObjects('progress', progress);

      return true;
    };
  }

  render(ctx, left, top, styleOverride, fabricObject) {
    const circleSize = 22;
    const diamondSize = 10;
    let circleColor = '#FFFFFF';
    let diamondColor = '#333333';

    if (this.isActive(fabricObject)) {
      circleColor = '#0073CF';
      diamondColor = '#FFFFFF';
    } else if (this.isHovered()) {
      diamondColor = '#0073CF';
    }

    ctx.save();
    ctx.fillStyle = circleColor;
    ctx.beginPath();
    ctx.arc(left, top, circleSize / 2, 0, 2 * Math.PI, false);
    ctx.shadowBlur = 8;
    ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
    ctx.fill();
    ctx.restore();

    ctx.save();
    ctx.fillStyle = diamondColor;
    ctx.beginPath();
    ctx.moveTo(left, top - diamondSize / 2);
    ctx.lineTo(left + diamondSize / 2, top);
    ctx.lineTo(left, top + diamondSize / 2);
    ctx.lineTo(left - diamondSize / 2, top);
    ctx.fill();
    ctx.restore();
  }
}

export default ProgressBarControl;
